import classname from "classnames";
import { returnIconByMenuCode } from "constants/layout";
import { useListMenu } from "hooks";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { toggleLeftmenu } from "../../store/actions";
import { Menu } from "antd";

const menu = [
  {
    id: 900,
    menuName: "Đơn của tôi",
    menuCode: "GS_MENU_MY_ORDER_LIST",
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    accessLink: "my-orders",
    children: [],
  },
  {
    id: 920,
    menuName: "Quản lý đơn",
    menuCode: "GS_MENU_ORDER_LIST",
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    accessLink: "manage-orders",
    children: [],
  },
  {
    id: 930,
    menuName: "Báo cáo",
    menuCode: "GS_MENU_REPORT_LIST",
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    accessLink: "/report-management/list",
    children: [],
  },
  {
    id: 950,
    menuName: "Import",
    menuCode: "GS_MENU_IMPORT_LIST",
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    accessLink: "/import-management/list",
    children: [],
  },
  {
    id: 1004,
    menuName: "Danh mục",
    menuCode: "GS_MENU_CONFIG_MANAGE",
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    accessLink: null,
    children: [
      {
        id: 1005,
        menuName: "Danh sách chành xe",
        menuCode: "GS_MENU_BUS_LIST",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        accessLink: "/bus/list",
        children: [],
        moreAccessLink: ["/bus/create"],
      },
      {
        id: 1006,
        menuName: "Danh sách tuyến vận chuyển",
        menuCode: "GS_MENU_ROUTE_LIST",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        accessLink: "/route/list",
        children: [],
        moreAccessLink: ["/route/create"],
      },
      {
        id: 1007,
        menuName: "Danh sách khách hàng",
        menuCode: "GS_MENU_CUSTOMER_LIST",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        accessLink: "/customer/list",
        children: [],
        moreAccessLink: ["/customer/create"],
      },
      {
        id: 1008,
        menuName: "Danh sách người dùng",
        menuCode: "GS_MENU_USER_PROFILE_LIST",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        accessLink: "/user-profile/list",
        children: [],
        moreAccessLink: ["/user-profile/create"],
      },
      {
        id: 1009,
        menuName: "Danh sách phân bổ đơn vị vận chuyển",
        menuCode: "GS_MENU_LIST_ALLOCATE_SHIPPING_UNIT",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        accessLink: "/allocate-shipping-unit/list",
        children: [],
        moreAccessLink: [],
      },

      {
        id: 1010,
        menuName: "Thông tin phân bổ runner",
        menuCode: "GS_MENU_LIST_ALLOCATE_RUNNER",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        accessLink: "/allocate-runner/list",
        children: [],
        moreAccessLink: [],
      },
      {
        id: 1011,
        menuName: "Danh sách đơn vị vận chuyển",
        menuCode: "GS_MENU_LIST_TRANSPORT",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        accessLink: "/transport/list",
        children: [],
        moreAccessLink: [],
      },
    ],
  },
];

const menuSale = [
  {
    id: 900,
    menuName: "Đơn của tôi",
    menuCode: "GS_MENU_MY_ORDER_LIST",
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    accessLink: "my-orders",
    children: [],
  },
];

const menuLogAdmin = [
  {
    id: 920,
    menuName: "Quản lý đơn tổng",
    menuCode: "GS_MENU_ORDER_LIST",
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    accessLink: "manage-orders",
    children: [],
  },
  {
    id: 940,
    menuName: "Quản lý đơn làm việc",
    menuCode: "GS_MENU_ORDER_LIST",
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    accessLink: "manage-orders-active",
    children: [],
  },
  {
    id: 930,
    menuName: "Báo cáo",
    menuCode: "GS_MENU_REPORT_LIST",
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    accessLink: "/report-management/list",
    children: [],
  },
  {
    id: 950,
    menuName: "Import",
    menuCode: "GS_MENU_REPORT_LIST",
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    accessLink: "/import-management/list",
    children: [],
  },
  {
    id: 1004,
    menuName: "Danh mục",
    menuCode: "GS_MENU_CONFIG_MANAGE",
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    accessLink: null,
    children: [
      {
        id: 1005,
        menuName: "Danh sách chành xe",
        menuCode: "GS_MENU_BUS_LIST",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        accessLink: "/bus/list",
        children: [],
        moreAccessLink: ["/bus/create"],
      },
      {
        id: 1006,
        menuName: "Danh sách tuyến vận chuyển",
        menuCode: "GS_MENU_ROUTE_LIST",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        accessLink: "/route/list",
        children: [],
        moreAccessLink: ["/route/create"],
      },
      {
        id: 1007,
        menuName: "Danh sách khách hàng",
        menuCode: "GS_MENU_CUSTOMER_LIST",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        accessLink: "/customer/list",
        children: [],
        moreAccessLink: ["/customer/create"],
      },
      {
        id: 1008,
        menuName: "Danh sách người dùng",
        menuCode: "GS_MENU_USER_PROFILE_LIST",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        accessLink: "/user-profile/list",
        children: [],
        moreAccessLink: ["/user-profile/create"],
      },
      {
        id: 1009,
        menuName: "Danh sách phân bổ đơn vị vận chuyển",
        menuCode: "GS_MENU_LIST_ALLOCATE_SHIPPING_UNIT",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        accessLink: "/allocate-shipping-unit/list",
        children: [],
        moreAccessLink: [],
      },

      {
        id: 1010,
        menuName: "Thông tin phân bổ runner",
        menuCode: "GS_MENU_LIST_ALLOCATE_RUNNER",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        accessLink: "/allocate-runner/list",
        children: [],
        moreAccessLink: [],
      },
      {
        id: 1011,
        menuName: "Danh sách đơn vị vận chuyển",
        menuCode: "GS_MENU_LIST_TRANSPORT",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        accessLink: "/transport/list",
        children: [],
        moreAccessLink: [],
      },
    ],
  },
];

const ConfigMenu = props => {
  const [menuMain, setMenuMain] = useState([]);
  const [menuOpen, setMenuOpen] = useState({});
  const dispatch = useDispatch();

  const onFetchMenuSuccess = response => {
    // Create a map to store unique menuCode and their corresponding items
    const uniqueMenuCodeMap = {};
    // Iterate over the menu items and keep track of the items with the most children for each menuCode
    response.items.forEach(item => {
      const { menuCode, children } = item;

      // If the current menuCode is not already present in the map or it has more children, update the map with the current item
      if (
        !uniqueMenuCodeMap[menuCode] ||
        children.length > uniqueMenuCodeMap[menuCode].children.length
      ) {
        uniqueMenuCodeMap[menuCode] = item;
      }
    });

    // Convert the map values back to an array to get the final result
    const uniqueItems = Object.values(uniqueMenuCodeMap);
    setMenuMain(uniqueItems);
  };

  const { refetch: fetchMenu } = useListMenu(onFetchMenuSuccess);

  useEffect(() => {
    fetchMenu();
  }, []);

  const toggleMenu = key => {
    setMenuOpen(prevMenuOpen => ({
      [key]: !prevMenuOpen[key],
    }));
  };

  return (
    <React.Fragment>
      {menuMain
        .sort((a, b) => a.menuOrder - b.menuOrder)
        .filter(item => item.accessLink !== "notification-management/list")
        .map((childItem, index) => {
          return (
            <React.Fragment key={childItem.id}>
              <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle arrow-none d-flex align-items-center"
                  onClick={e => {
                    if (childItem.children?.length > 0) {
                      e.preventDefault();
                      if (window.innerWidth <= 990) {
                        toggleMenu(index);
                      }
                    } else {
                      dispatch(toggleLeftmenu(false));
                    }
                  }}
                  to={childItem.accessLink ? childItem.accessLink : "/#"}
                >
                  {/* <i
                    className={
                      returnIconByMenuCode(childItem.menuCode) + " me-2"
                    }
                  ></i> */}
                  {childItem.menuName} {props.menuOpen}
                  {childItem.children?.length > 0 && (
                    <div className="arrow-down"></div>
                  )}
                </Link>
                {childItem.children?.length > 0 && (
                  <div
                    className={classname("dropdown-menu", {
                      show: menuOpen[index],
                    })}
                  >
                    {childItem.children.map((child, index1) => {
                      let dataHref = "";
                      if (child.moreAccessLink) {
                        dataHref = child.moreAccessLink.join("___");
                      }
                      return (
                        <Link
                          onClick={() => dispatch(toggleLeftmenu(false))}
                          key={child.id}
                          className="dropdown-item"
                          to={child.accessLink
                            .toLowerCase()
                            .split("_")
                            .join("-")}
                          datahref={dataHref}
                        >
                          <span style={{ marginLeft: "5px" }}>
                            {child.menuName}
                          </span>
                        </Link>
                      );
                    })}
                  </div>
                )}
              </li>
            </React.Fragment>
          );
        })}
    </React.Fragment>
  );
};

ConfigMenu.propTypes = {
  menuArr: PropTypes.any,
  menuOpen: PropTypes.any,
};

export default ConfigMenu;
